module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('i', {
    directives: [{
      name: "click-outside",
      rawName: "v-click-outside",
      value: (_vm.close),
      expression: "close"
    }],
    staticClass: "messages huge ico-message pointer dark mr-3",
    on: {
      "click": _vm.open
    }
  }, [_c('span', {
    staticClass: "number bold text-center lightest bg-brand"
  }, [_vm._v(_vm._s(_vm.messages.length))]), _vm._v(" "), (_vm.isVisible) ? _c('div', {
    staticClass: "box cursor-default"
  }, [_c('div', {
    staticClass: "wrapper"
  }, [_c('h5', [_vm._v("People")]), _vm._v(" "), _c('div', {
    staticClass: "write fs-small border-light rounded p-2"
  }, [_c('i', {
    staticClass: "ico-search larger"
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "text",
      "placeholder": "Type a name"
    },
    on: {
      "keyup": _vm.typing
    }
  })])]), _vm._v(" "), (_vm.messages) ? _c('ul', {
    staticClass: "list"
  }, _vm._l((_vm.messages), function(item) {
    return _c('li', {
      class: !item.is_read ? 'normal' : 'bold'
    }, [_c('img', {
      attrs: {
        "src": "/static/images/avatar.png",
        "alt": ""
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "details ml-3"
    }, [_c('p', [_vm._v(_vm._s(item.user))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm._f("ellipsis")(item.intro, 45)))])])])
  }), 0) : _c('div', [_c('p', [_vm._v("You have no messages.")])]), _vm._v(" "), _vm._m(0)]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "options bg-faded border-top-light text-right"
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("View all")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-24908b6a"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/Messages.vue
// module id = 2057
// module chunks = 0